/**
 * Sentry Configuration
 * Controls error monitoring and performance tracking
 */

// Sentry DSN - obtain from your Sentry project settings
// Can be overridden via VITE_SENTRY_DSN environment variable
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN ||
    "https://e4894561edc440ec70253d20b6470bc4@o4510497898627072.ingest.us.sentry.io/4510497975435264";

// Environment detection
export const SENTRY_ENVIRONMENT = import.meta.env.MODE || "development";

// Release version - ties errors to specific deployments
export const SENTRY_RELEASE = import.meta.env.VITE_SENTRY_RELEASE || "1.0.0";

// Enable/disable Sentry (disabled if no DSN)
export const SENTRY_ENABLED = Boolean(SENTRY_DSN);

// Sample rates for performance monitoring
// Lower in production to reduce costs, higher in dev for debugging
export const SENTRY_TRACES_SAMPLE_RATE =
    import.meta.env.PROD ? 0.2 : 1.0; // 20% in prod, 100% in dev

// Session Replay sample rates
export const SENTRY_REPLAY_SESSION_SAMPLE_RATE = 0.1; // 10% of sessions
export const SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE = 1.0; // 100% when error occurs
